import styled from "@yb/styled-px2rem";
import SpriteImage from "@PUBLIC/M/images/ico/ico_spr.png";
import {Ellipsis} from "@FRAMEWORK/ui/mobile/text";

const CotentBox = styled.div`
	padding: 0 15px 30px;
	background: #fff;
	text-align: left;
`;
const PromotionWrap = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 30px;
`;
const Title = styled.h4<{line?: boolean}>`
	padding: 30px 15px 15px;
	font-size: 18px;
	font-weight: bold;
	color: var(--emp-color);
	border-bottom: ${props => (props.line ? "1px solid var(--line-color)" : "")};
	span {
		padding-left: 5px;
		font-size: 14px;
		font-weight: normal;
		color: var(--default-color);
	}
`;
const PointWrap = styled.ul`
	padding: 30px;
	border: 1px solid var(--line-color);
	li {
		position: relative;
		display: flex;
		justify-content: space-between;
		&::before {
			position: absolute;
			top: 50%;
			left: -10px;
			display: block;
			width: 4px;
			height: 4px;
			border-radius: 50%;
			background-color: var(--bl-color);
			transform: translateY(-50%);
			content: "";
		}
		span,
		em {
			font-weight: bold;
		}
		> span > em {
			margin-right: 5px;
		}
	}
	> li + li {
		margin-top: 10px;
	}
`;

const PromotionList = styled.ul`
	display: flex;
	flex-direction: column;
`;
const PromotionListItem = styled.li`
	position: relative;
	padding: 25px 15px;
	&:not(:last-child) {
		border-bottom: 1px solid var(--line-color);
	}
	> a {
		display: flex;
		flex-direction: column;
		gap: 5px;
		width: 100%;
		height: 100%;
		> dl {
			display: flex;
			align-items: center;
			dt {
				width: 45px;
				color: var(--emp-color);
			}
		}
	}
`;
const PromotionTitle = styled.strong`
	margin-bottom: 5px;
	font-size: 15px;
	color: var(--emp-color);
	${Ellipsis(1)}
`;
const LinkText = styled.span`
	position: absolute;
	text-decoration: underline;
	right: 15px;
	bottom: 26px;
	color: var(--emp-color);
`;
const NoData = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100px;
	font-size: 15px;
	color: #828282;
`;
const NotiBox = styled.div`
	height: 100%;
	padding: 30px 15px;
	background: #f3f3f3;
	ul {
		li {
			word-break: keep-all;
		}
		li + li {
			margin-top: 10px;
		}
	}
`;
const InfoTitle = styled.h5`
	position: relative;
	display: flex;
	align-items: center;
	line-height: 1;
	margin-bottom: 10px;
	font-size: 15px;
	font-weight: bold;
	color: var(--emp-color);
	&::before {
		display: inline-block;
		width: 18px;
		height: 20px;
		background: url(${SpriteImage}) no-repeat 0 -118px;
		background-size: 300px 300px;
		vertical-align: middle;
		content: "";
	}
`;
const BulletList = styled.ul`
	li {
		font-size: 15px;
		color: var(--default-color);
	}
`;
const PromotionName = styled.a`
	width: fit-content;
	text-align: left;
	text-decoration: underline;
	${Ellipsis(2)}

	&:active, &:hover {
		text-decoration: underline;
	}
`;
const TextAlign = styled.div`
	text-align: center;
`;
const InsuranceLink = styled.a`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 40px;
	margin: 30px 0 37px;
	background-color: var(--default-color);
	color: #fff;
`;

export {
	CotentBox,
	InfoTitle,
	LinkText,
	NoData,
	NotiBox,
	PointWrap,
	PromotionList,
	PromotionListItem,
	PromotionTitle,
	PromotionWrap,
	Title,
	BulletList,
	PromotionName,
	TextAlign,
	InsuranceLink,
};
